import { createUseStyles } from 'react-jss'
import { WHITE, DARK_GRAY_20, DARK_GRAY_05 } from '@omnilert/components'

export default createUseStyles({
  button: {
    backgroundColor: DARK_GRAY_20,
    border: 'none',
    borderRadius: 20,
    color: WHITE,
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '-0.02em',
    padding: '4px 10px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  buttonText: {
    marginRight: '5px'
  },
  headerText: {
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '-0.02em'
  },
  reportHeader: {
    borderBottom: ['1px', 'solid', DARK_GRAY_05],
    color: WHITE,
    fontFamily: 'BentonSansBold',
    fontSize: '18px'
  },
  reportBody: {
    paddingBottom: '5px',
    paddingTop: '5px'
  },
  reportFooter: {
    borderTop: ['1px', 'solid', DARK_GRAY_05],
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '5px'
  }
})
